import { styled, Typography } from '@mui/material';
import ZizziPoint from 'assets/icons/ZizziPoint';
import { theme } from 'assets/themes/zizzi';

const textColor = theme.palette.secondary.main;

interface CostProps {
  highlight: string;
}

export const Wrapper = styled('div')`
  align-items: center;
  background: transparent !important;
  display: inline-flex;
`;

export const OriginalCost = styled(Typography)`
  padding-right: 5px;
  text-decoration: line-through;
  text-decoration-thickness: 2px;
  opacity: 70%;
`;

export const Cost = styled(Typography)<CostProps>`
  font-weight: 900;
  ${({ highlight }) => highlight === 'true' && `color: ${textColor};`}
`;

export const StyledLogo = styled(ZizziPoint)`
  margin-bottom: -3px;
  height: 25px;
  width: 25px;
`;
